/*
 * Compte a rebours de fin d'offre cadeau.
 *
 * ELEMENT PERSONNALISE, et c'est la seule forme qui tienne ici. Le tiroir panier
 * remplace `.drawer__inner.innerHTML` en entier a chaque mise a jour : un script
 * qui aurait pose un setInterval sur un noeud du tiroir perdrait son noeud au
 * premier ajout au panier, et le compteur se figerait sans erreur. Un custom
 * element rebranche son propre intervalle a chaque insertion dans le DOM
 * (connectedCallback) et le coupe a chaque retrait. Le re-render le repare tout
 * seul, sans que personne ait a s'en souvenir.
 *
 * Ce fichier est charge depuis `snippets/ariane-offerte-config.liquid`, donc
 * depuis <head>, HORS de <cart-drawer> : la definition survit au re-render.
 *
 * L'INSTANT DE FIN vient de l'attribut `end`, rempli par Liquid depuis
 * `snippets/ariane-offerte-window.liquid`. Il n'est ecrit nulle part ailleurs.
 * Un compte a rebours qui tombe a zero a un autre instant que la vraie fin de
 * l'offre est une rarete annoncee non tenue (L121-4 7 du code de la
 * consommation) : le seul garde-fou fiable est de n'avoir qu'une source.
 *
 * A zero, l'element se RETIRE. Il n'affiche jamais 00:00:00 fixe, ni un nombre
 * negatif : la page servie ensuite n'aura de toute facon plus l'offre, la
 * fenetre Liquid etant passee en `off`.
 */
(function () {
  'use strict';

  if (customElements.get('cadeau-timer')) return;

  var DEUX = function (n) { return n < 10 ? '0' + n : String(n); };

  customElements.define('cadeau-timer', class extends HTMLElement {
    connectedCallback() {
      this.fin = Date.parse(this.getAttribute('end'));
      /* Date invalide : on disparait plutot que d'afficher « NaN ». */
      if (!isFinite(this.fin)) { this.remove(); return; }

      this.valeur = this.querySelector('[data-timer-valeur]');
      if (!this.valeur) { this.remove(); return; }

      this.rendu();
      /* 1 s suffit : la plus petite unite affichee est la seconde. */
      this.horloge = setInterval(this.rendu.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.horloge);
    }

    rendu() {
      var reste = Math.floor((this.fin - Date.now()) / 1000);
      if (reste <= 0) { this.remove(); return; }

      var h = Math.floor(reste / 3600);
      var m = Math.floor((reste % 3600) / 60);
      var s = reste % 60;

      /* Au-dela de 10 h, la seconde qui defile est du bruit : elle attire l'oeil
         sur un chiffre qui ne veut rien dire a cette echelle. On ne la montre
         qu'a partir du moment ou elle porte de l'information. */
      this.valeur.textContent = h >= 10
        ? h + ' h ' + DEUX(m)
        : DEUX(h) + ':' + DEUX(m) + ':' + DEUX(s);

      /* Le titre du document n'est pas touche : un compteur dans l'onglet suit
         le client sur tout le site, y compris hors des pages de l'offre. */
    }
  });
})();
